import { CategoryCover } from "@/components/marketplace"
import type { CategoryCoverSection } from "@/features/feed/contract"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

// The banner runs edge to edge, so no `gut`. `product` stays in the wire contract for
// the backend's sake and is deliberately not rendered — a banner carries no commerce.
export const CategoryCoverFeedSection = ({ section, context }: FeedSectionProps<CategoryCoverSection>) => {
  const { eyebrow, title, accent, sub, cta, image } = section.data
  return (
    <SectionFrame section={section} context={context} ownsHeader>
      <CategoryCover
        eyebrow={eyebrow}
        title={title}
        accent={accent}
        sub={sub}
        cta={cta?.label}
        ctaHref={cta ? resolveFeedLink(cta.link, context.countryCode, context.page) : undefined}
        image={image.url}
        imageAlt={image.alt}
        priority={context.isLeadSection}
        headingLevel={context.isLeadSection ? "h1" : "h2"}
      />
    </SectionFrame>
  )
}
